import React, { PropsWithChildren, useEffect } from "react";

import { configureDatadog } from "@storebrand-digital/common-datadog";
import { NoProps } from "Utils/types";

export const DatadogProvider = ({
  children,
}: PropsWithChildren<NoProps>): React.ReactElement => {
  useEffect(() => {
    configureDatadog({
      environment: window.env.ENVIRONMENT,
      clientPublicToken: "pubca2f65d4ade1082371b0f9256a628e9c",
      appId: "0d022770-c6f6-420d-9da8-8e4209cb70d9",
      appName: "buy-insurance-web",
      appVersion: getCommitHash(),
      configureLogging: true,
      forwardConsoleLogs: ["error", "warn"],
    });
  }, []);

  return <>{children}</>;
};

const getCommitHash = (): string => {
  const metaTag = document.getElementById("commitHash");
  if (metaTag) {
    const commitHash = metaTag.getAttribute("content");
    return commitHash || "undefined";
  }
  return "undefined";
};
